export default __webpack_public_path__ + "1566cf373c2f2615902841ee37573794.svg";